import axios from "../plugins/axios";

const baseUrl = "/web_api/v1/task_list";

export default {
  paginate(page = 1, perPage = 15, filter = null) {
    return axios
      .get(`${baseUrl}`, {
        params: {
          page,
          perPage,
          ...filter,
        },
      })
      .then((response) => response.data);
  },

  get(taskListId) {
    return axios
      .get(`${baseUrl}/${taskListId}`, {
        params: {
          includes: ["taskListItems"],
        },
      })
      .then((response) => response.data);
  },

  save(taskListTemplateId, data) {
    return axios
      .post(`${baseUrl}/${taskListTemplateId}`, data)
      .then((response) => response.data);
  },

  update(taskListId, data) {
    return axios
      .patch(`${baseUrl}/${taskListId}`, data)
      .then((response) => response.data);
  },

  destroy(taskListId) {
    return axios
      .delete(`${baseUrl}/${taskListId}`)
      .then((response) => response.data);
  },
};
